import { slugify } from "@/js/helpers/slugify";
import ReferenceMark from "./ReferenceMark.vue";
import SNPsNode from "./SNPsNode.vue";
import { useRouteLocale } from "@/composables/useRouteLocale";

const slugifyHeading = (node) => {
   const headingText = node.content && node.content.length && node.content[0].text;
   if (!headingText) {
      console.error("Text content not found in node:", node);
      return null;
   }
   return slugify(headingText);
};

export default {
   nodes: {
      horizontalRule(node) {
         return {
            tag: "hr",
         };
      },
      blockquote(node) {
         const dataAttributes = {};
         let classes = [];

         if (node.attrs) {
            // Handle backgroundColor -> data-bg-color
            if (node.attrs.backgroundColor) {
               dataAttributes["data-bg-color"] = node.attrs.backgroundColor;
            }

            // Handle darkMode -> .dark class
            if (node.attrs.darkMode === true) {
               classes.push("dark");
            }
         }

         // Combine data attributes with classes
         const elementData = { ...dataAttributes };
         if (classes.length > 0) {
            elementData.class = classes.join(" ");
         }

         return {
            tag: "blockquote",
            data: elementData,
         };
      },
      bulletList(node) {
         return {
            tag: "ul",
         };
      },
      codeBlock(node) {
         return {
            tag: [
               "pre",
               {
                  tag: "code",
                  attrs: node.attrs,
               },
            ],
         };
      },
      hardBreak(node) {
         return {
            tag: "br",
         };
      },
      spacer() {
         return {
            tag: "span",
            data: {
               "data-type": "rich-text-spacer",
               class: "rich-text-spacer",
               "aria-hidden": "true",
            },
         };
      },
      heading(node) {
         const anchorId = slugifyHeading(node);
         return {
            tag: `h${node.attrs.level}`,
            data: { id: anchorId },
         };
      },
      listItem(node) {
         return {
            tag: "li",
         };
      },
      orderedList(node) {
         return {
            tag: "ol",
         };
      },
      paragraph(node) {
         return {
            tag: "p",
         };
      },
      styledParagraph(node) {
         return {
            tag: "p",
            data: { ...node.attrs },
         };
      },
      table() {
         return {
            tag: "table",
         };
      },
      tableRow() {
         return {
            tag: "tr",
         };
      },
      tableHeader() {
         return {
            tag: "th",
         };
      },
      tableCell() {
         return {
            tag: "td",
         };
      },
      snps(node) {
         return {
            tag: SNPsNode,
            data: { attr: { ...node.attrs }, rsids: node.attrs.rsids },
            skipContent: true,
         };
      },
   },
   marks: {
      bold() {
         return {
            tag: "strong",
         };
      },
      reference() {
         return {
            tag: ReferenceMark,
            skipContent: true,
            isVueComponent: true,
         };
      },
      strike() {
         return {
            tag: "strike",
         };
      },
      underline() {
         return {
            tag: "u",
         };
      },
      strong() {
         return {
            tag: "strong",
         };
      },
      code() {
         return {
            tag: "code",
         };
      },
      italic() {
         return {
            tag: "i",
         };
      },
      link(node) {
         const attrs = { ...node.attrs };
         const { linktype = "url" } = node.attrs;

         if (linktype === "email") {
            attrs.href = `mailto:${attrs.href}`;
         } else if (linktype === "phone") {
            attrs.href = `tel:${attrs.href}`;
         } else {
            // add locale param to internal links
            if (!attrs.href.startsWith("mailto") && !attrs.href.startsWith("http")) {
               const { localePath } = useRouteLocale();
               const optionalSlash = attrs.href.startsWith("/") ? "" : "/";
               attrs.href = `${localePath.value}${optionalSlash}${attrs.href}`;
            }

            // if anchor attribute is set, add anchor to all links
            if (attrs.anchor) {
               attrs.href = `${attrs.href}#${attrs.anchor}`;
               delete attrs.anchor;
            }
         }

         return {
            tag: "a",
            data: { ...attrs },
         };
      },
      styled(node) {
         return {
            tag: "span",
            data: { ...node.attrs },
         };
      },
   },
};
